import {memoize} from 'lodash';
import fetchJSON from '../fetchJSON';
import fetchUser from './fetchUser';

export default memoize(async (): Promise<LayerTypeCategory[]> => {
    const url = '/mapsources.json?vector=1&deprecated=1&app=gaiagps-ng-2019&web=1';
    const mapsources = await fetchJSON.memoized(url, {
        credentials: 'same-origin'
    });

    return [
        ...mapsources.categories,
        ...!(await fetchUser()).isAuthenticated ? [] : [{
            name: 'Custom Imports',
            id: 'custom',
            rank: 100,
            description: '',
            icon: '',
            // eslint-disable-next-line camelcase
            icon_url: '',
            app: 'gaiagps-ng-2019',
        }]
    ];
});
